import {
  radioUI,
  radioSchema,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { marriageEndOptions } from '../../../utils/labels';
import { customTextSchema } from '../../definitions';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    howMarriageEnded: {
      ...radioUI({
        title: content['household-veteran-marriage-end-title'],
        labels: marriageEndOptions,
        required: formData => formData.marriedToVeteranAtTimeOfDeath === false,
        labelHeaderLevel: 3,
      }),
    },
    marriageEndedExplanation: textUI({
      title: content['household-veteran-marriage-end-explanation'],
      required: formData => formData?.howMarriageEnded === 'other',
      errorMessages: {
        required: content['household-veteran-marriage-end-explanation-error'],
      },
      maxLength: 256,
      expandUnder: 'howMarriageEnded',
      expandUnderCondition: 'other',
    }),
  },
  schema: {
    type: 'object',
    required: [],
    properties: {
      howMarriageEnded: radioSchema(Object.keys(marriageEndOptions)),
      marriageEndedExplanation: customTextSchema,
    },
  },
};
